var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"stroke":"#fff","d":"M23.5 4.5v15H.5v-15z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }